.k0{pointer-events:auto;}